import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetDailyReportList(payload) {
    return Api().post("/api/admin/getdailysalesreports", payload);
  },
  GetFilmWiseCollectionReport(payload) {
    return Api().post("/api/admin/getfilmwisecollectionreports", payload);
  },
  GetPerformanceReportList(payload) {
    return Api().post("/api/admin/getperformancereports", payload);
  },
  GetGcanReport(payload) {
    return Api().post("/api/admin/getgcamreports", payload);
  },
  GetAggregatorsReportList(payload) {
    return Api().post("/api/admin/getaggregatorreports", payload);
  },
  GetScreenWiseCollectionReport(payload) {
    return Api().post("/api/admin/getscreenwisecollectionsreports", payload);
  },
  GetDistributorReportList(payload) {
    return Api().post(
      "/api/admin/v2/getdistributorwisecollectionsreports",
      payload
    );
  },
  GetDistributorReportListV4(payload) {
    return Api().post(
      "/api/admin/v4/getdistributorwisecollectionsreports",
      payload
    );
  },
  GetDistributorDetailedSummaryReport(payload) {
    return Api().post("/api/admin/detailedDistributorReport", payload);
  },
  GetDistributorDetailedSummaryReportLebanon(payload) {
    return Api().post("/api/admin/detailedDistributorReportLebanon", payload);
  },
  // /api/admin/v2/getdistributorwisecollectionsreports
  GetDistributorMovie(payload) {
    return Api().post("/api/admin/getdistributorsmoviesbydistributor", payload);
  },
  GetDistributorMovieFormat(payload) {
    return Api().post(
      "/api/admin/getdistributorsmovieswithformatbydistributor",
      payload
    );
  },
  GetSummaryReportList(payload) {
    return Api().post("/api/admin/getsummaries", payload);
  },

  GetPurchaseOrderList(payload) {
    return Api().post("/api/admin/getpurchaseorder", payload);
  },
  GetInvoiceList(payload) {
    return Api().post("/api/admin/getinvoice", payload);
  },
  GetMunicipaltyReport(payload) {
    return Api().post("/api/admin/getMunicipaltyReport", payload);
  },
  GetAdvanceBookingReport(payload) {
    return Api().post("/api/admin/getAdvanceBookingReport", payload);
  },

  GetMovieAnalytics(payload) {
    return Api().post("/api/admin/v2/getmovieanalytics", payload);
  },

  GetExpiryReports(payload) {
    return Api().post("/api/admin/v2/getExpiryReport", payload);
  },
  GetAddOnsReport(payload) {
    return Api().post("/api/admin/v2/getAddOnsReport", payload);
  },
  GetCutomizationReport(payload) {
    return Api().post("/api/admin/v2/getCustomizationReport", payload);
  },
  GetOccupancyReport(payload) {
    return Api().post("/api/admin/getOccupancyStatus", payload);
  },
  GetCinemaOverview(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/mycinema_schedule_overview${query}`);
  },
  UpdateCinemaOverView(payload) {
    return Api().put(
      `/api/admin/mycinema_schedule_overview/${payload.md_id}`,
      payload
    );
  },
  GetGcamNewExcel(payload) {
    return Api().post(`api/admin/v2/gcamReportV2`, payload);
  },
  GetDistributorCollectionReportV5(payload) {
    return Api().post(
      `/api/admin/v2/get-distributor-collection-report-v5`,
      payload
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/ReportsService.js